import { COU_httpGet, COU_httpPost } from "@/utils/http";

// 获取下单配置
async function GetMallRemarkTemplate(relationId) {
  var url = `shopSetting/oneOrderSetting?branchGroupRelId=${relationId}`;
  var r = await COU_httpGet({ url });
  var remarkTemplate = {};
  var msg = ``;
  var success = false;
  try {
    msg = r.msg;
    success = r.success;
    remarkTemplate = r.result;
  } catch (error) {
    console.log(error);
  }

  return { remarkTemplate: remarkTemplate || {}, msg, success };
}

// 保存订单配置
async function SaveMallRemarkTemplate(relationId, data, onlyMall) {
  //onlyMall 指单店铺
  let url;
  if (onlyMall) {
    url = `/shopSetting/saveOneOrderSetting`;
  } else {
    url = `/shopSetting/saveOneOrderSetting?branchGroupRelId=${relationId}`;
  }
  // var url = `/shopSetting/saveOneOrderSetting?branchGroupRelId=${relationId}`;
  var r = await COU_httpPost({ url, data });
  var success = false;
  var msg = ``;
  try {
    success = r.success;
    msg = r.msg;
  } catch (error) {
    console.log(error);
  }

  return { msg, success };
}

export default { GetMallRemarkTemplate, SaveMallRemarkTemplate };
